import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
    invoiceDetailsDialogAction,
    InvoiceDetailsState,
} from '../../redux/slices/invoiceDetailsDialogSlice';
import { InvoiceData } from '../../models/Invoice';
// import { InvoiceDetailsDialogProps } from '../../models/InvoiceDetailsDialogProps';

const useInvoiceDetailsDialog = () => {
    const state: InvoiceDetailsState = useAppSelector(
        (state) => state.invoiceDetailsDialog
    );
    const dispatch = useAppDispatch();

    const showDialog = useCallback((open: boolean, props: InvoiceData) => {
        if (open && props) {
            dispatch(invoiceDetailsDialogAction.setInvoiceDetailsDialog(props));
            dispatch(invoiceDetailsDialogAction.setOpen(open));
        } else {
            dispatch(invoiceDetailsDialogAction.setInvoiceDetailsDialog(null));
            dispatch(invoiceDetailsDialogAction.setOpen(open));
        }
    }, []);

    const closeDialog = () => {
        dispatch(invoiceDetailsDialogAction.setOpen(false));
        dispatch(invoiceDetailsDialogAction.setInvoiceDetailsDialog(null));
    };

    return { ...state, showDialog, closeDialog };
};

export default useInvoiceDetailsDialog;
